const state = {
  currentSortId: '',
  currentSortName: '',
  currentRouterName: '',
  newsSorts: [],
  venuePageType: ''
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js